/*
  Pruvodce vykupem pro sekci "KF Výkup – průvodce".

  Kroky: model -> uloziste -> stav -> rychle otazky -> vysledek.
  Vysledek preda zakaznika na Shopify Forms:
  - kdyz je blok aplikace vlozeny primo do sekce, ukaze ho pod vysledkem,
  - jinak odroluje na formular na strance (data-form-selector).
  Shrnuti se vlozi do pole s poznamkou ve formulari a jde i zkopirovat.
*/
(function () {
  if (customElements.get('trade-in-wizard')) return;

  const STEPS = ['model', 'storage', 'condition', 'checks', 'result'];

  const normalize = (text) =>
    (text || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');

  class TradeInWizard extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      try {
        this.models = JSON.parse(this.querySelector('[data-kfw-models]').textContent);
      } catch (e) {
        this.models = [];
      }

      this.state = { model: null, storage: null, condition: null, checks: {} };
      this.checkEls = Array.from(this.querySelectorAll('[data-check]'));
      this.history = [];

      this.bind();
      this.renderFromPrices();
      this.show('model', false);
    }

    // Na dlazdici modelu ukaze nejnizsi cenu pres kapacity pro zvoleny stav.
    renderFromPrices() {
      if (!this.showPrice || this.dataset.showFrom !== 'true') return;
      const key = this.dataset.fromCondition || 'A';
      const prefix = (this.dataset.fromPrefix || '').trim();
      const min = parseFloat(this.dataset.minPrice) || 0;

      this.querySelectorAll('[data-model]').forEach((tile) => {
        const model = this.models.find((m) => m.id === tile.dataset.model);
        const label = tile.querySelector('[data-kfw-from]');
        if (!model || !label) return;

        const values = model.storages
          .filter((s) => s.label)
          .map((s) => (s.prices && s.prices[key] != null && s.prices[key] !== '' ? parseFloat(s.prices[key]) : null))
          .filter((v) => v != null && !isNaN(v) && v >= min);

        if (!values.length) return;
        label.textContent = `${prefix ? prefix + ' ' : ''}${this.money(Math.min.apply(null, values))}`;
        label.hidden = false;
      });
    }

    get showPrice() {
      return this.dataset.showPrice === 'true';
    }

    get steps() {
      return STEPS.filter((step) => step !== 'checks' || this.checkEls.length > 0);
    }

    bind() {
      this.addEventListener('click', (event) => {
        const model = event.target.closest('[data-model]');
        const storage = event.target.closest('[data-storage]');
        const condition = event.target.closest('[data-condition]');
        const answer = event.target.closest('[data-answer]');

        if (model) return this.pickModel(model);
        if (storage) return this.pickStorage(storage);
        if (condition) return this.pickCondition(condition);
        if (answer) return this.pickAnswer(answer);
        if (event.target.closest('[data-kfw-back]')) return this.back();
        if (event.target.closest('[data-kfw-checks-next]')) return this.go('result');
        if (event.target.closest('[data-kfw-to-form]')) return this.toForm();
        if (event.target.closest('[data-kfw-copy]')) return this.copy();
      });

      const search = this.querySelector('[data-kfw-search]');
      if (search) {
        search.addEventListener('input', () => {
          const query = normalize(search.value);
          this.querySelectorAll('[data-model]').forEach((tile) => {
            tile.hidden = query !== '' && !normalize(tile.dataset.name).includes(query);
          });
        });
      }
    }

    /* --- navigace --- */

    show(step, focus = true) {
      this.current = step;
      this.querySelectorAll('[data-step]').forEach((el) => {
        el.hidden = el.dataset.step !== step;
      });

      const order = this.steps;
      const index = order.indexOf(step);
      this.querySelectorAll('[data-progress]').forEach((li) => {
        const i = order.indexOf(li.dataset.progress);
        li.hidden = i === -1;
        li.classList.toggle('is-done', i > -1 && i < index);
        li.classList.toggle('is-current', i === index);
      });

      if (step === 'result') this.renderResult();

      // Zamerne bez scrollIntoView - prepnuti kroku nesmi hybat strankou.
      if (focus) {
        const el = this.querySelector(`[data-step="${step}"]`);
        if (el) el.focus({ preventScroll: true });
      }
    }

    go(step) {
      this.history.push(this.current);
      this.show(step);
    }

    back() {
      const previous = this.history.pop();
      if (previous) this.show(previous);
    }

    get reduceMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    press(group, active) {
      group.forEach((el) => el.setAttribute('aria-pressed', el === active ? 'true' : 'false'));
    }

    /* --- volby --- */

    pickModel(tile) {
      this.press(Array.from(this.querySelectorAll('[data-model]')), tile);
      this.state.model = this.models.find((m) => m.id === tile.dataset.model) || null;
      this.state.storage = null;

      const storages = (this.state.model ? this.state.model.storages : []).filter((s) => s.label);
      const wrap = this.querySelector('[data-kfw-storages]');
      wrap.innerHTML = '';
      storages.forEach((s, i) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'kfw__chip';
        chip.dataset.storage = i;
        chip.setAttribute('aria-pressed', 'false');
        chip.textContent = s.label;
        wrap.appendChild(chip);
      });
      this.storages = storages;

      // jedina kapacita = neni co vybirat, krok preskocime
      if (storages.length === 1) {
        this.state.storage = storages[0];
        this.updateConditions();
        return this.go('condition');
      }
      this.go(storages.length === 0 ? 'condition' : 'storage');
    }

    pickStorage(chip) {
      this.press(Array.from(this.querySelectorAll('[data-storage]')), chip);
      this.state.storage = this.storages[parseInt(chip.dataset.storage, 10)];
      this.updateConditions();
      this.go('condition');
    }

    // Kdyz ma kapacita zadane presne ceny podle stavu, stav bez ceny se neukaze.
    // Stavy s nabidkou na vyzadani (data-quote) zustavaji videt vzdy.
    updateConditions() {
      const s = this.state.storage;
      const prices = s && s.prices;
      const explicit = prices && ['B', 'C', 'D'].some((k) => prices[k] != null);
      this.querySelectorAll('[data-condition]').forEach((card) => {
        const quote = card.dataset.quote === 'true';
        card.hidden = !!(!quote && this.showPrice && explicit && prices[card.dataset.condition] == null);
      });
    }

    pickCondition(card) {
      this.press(Array.from(this.querySelectorAll('[data-condition]')), card);
      this.state.condition = {
        key: card.dataset.condition,
        label: card.dataset.label,
        pct: parseFloat(card.dataset.pct) || 0,
        quote: card.dataset.quote === 'true',
      };
      this.go(this.checkEls.length ? 'checks' : 'result');
    }

    pickAnswer(button) {
      const row = button.closest('[data-check]');
      this.press(Array.from(row.querySelectorAll('[data-answer]')), button);
      this.state.checks[row.dataset.check] = {
        label: row.dataset.label,
        ok: button.dataset.answer === 'yes',
        deduct: parseFloat(row.dataset.deduct) || 0,
      };
      const done = this.checkEls.every((el) => this.state.checks[el.dataset.check]);
      this.querySelector('[data-kfw-checks-next]').disabled = !done;
    }

    /* --- vypocet --- */

    estimate() {
      const s = this.state.storage;
      const c = this.state.condition;
      if (!this.showPrice || !s || !c) return null;
      // poskozeny kus se neoceni automaticky - nabidka az po prohlidce
      if (c.quote) return null;

      // 1) presna cena pro kapacitu a stav, 2) jinak cena stavu A x procento stavu
      let price;
      const exact = s.prices && s.prices[c.key] != null && s.prices[c.key] !== '' ? parseFloat(s.prices[c.key]) : null;
      if (exact != null) {
        price = exact;
      } else {
        if (s.price == null || s.price === '') return null;
        price = (parseFloat(s.price) * c.pct) / 100;
      }

      Object.values(this.state.checks).forEach((check) => {
        if (!check.ok) price -= check.deduct;
      });

      const round = parseFloat(this.dataset.round) || 0;
      if (round > 0) price = Math.floor(price / round) * round;
      price = Math.max(0, Math.round(price));

      // symbolicke castky (napr. 10 Kc za poskozeny kus) nezobrazujeme, nabidka individualne
      const min = parseFloat(this.dataset.minPrice) || 0;
      return price < min ? null : price;
    }

    money(value) {
      // mezera pred menou, i kdyz ji v nastaveni nekdo nenapsal
      const currency = this.dataset.currency || '';
      const space = currency && !/^[\s\u00a0]/.test(currency) ? ' ' : '';
      return `${new Intl.NumberFormat('cs-CZ').format(value)}${space}${currency}`;
    }

    summaryLines() {
      const s = this.state;
      const lines = [];
      if (s.model) lines.push(['Model', s.model.name]);
      if (s.storage) lines.push(['Úložiště', s.storage.label]);
      if (s.condition) lines.push(['Stav', `${s.condition.key} – ${s.condition.label}`]);
      Object.values(s.checks).forEach((c) => lines.push([c.label, c.ok ? 'Ano' : 'Ne']));
      return lines;
    }

    summaryText() {
      const lines = this.summaryLines().map(([k, v]) => `${k}: ${v}`);
      const price = this.estimate();
      if (price != null) lines.push(`Orientační odhad: ${(this.dataset.prefix || '').trim()} ${this.money(price)}`.replace('  ', ' '));
      else if (this.state.condition && this.state.condition.quote) lines.push(`Orientační odhad: ${this.dataset.quoteLabel || 'nabídka na vyžádání'}`);
      return `Výkup – shrnutí z průvodce\n${lines.join('\n')}`;
    }

    renderResult() {
      const list = this.querySelector('[data-kfw-summary]');
      list.innerHTML = '';
      // model, kapacita a stav staci hodnotou, u otazek bez nazvu nedava "Ano/Ne" smysl
      const named = new Set(['Model', 'Úložiště', 'Stav']);
      this.summaryLines().forEach(([key, value]) => {
        const li = document.createElement('li');
        li.textContent = named.has(key) ? value : `${key}: ${value}`;
        list.appendChild(li);
      });

      const price = this.estimate();
      const wrap = this.querySelector('[data-kfw-price-wrap]');
      const noPrice = this.querySelector('[data-kfw-no-price]');
      const bonus = this.querySelector('[data-kfw-bonus]');
      const disclaimer = this.querySelector('[data-kfw-disclaimer]');

      const quote = !!(this.state.condition && this.state.condition.quote);
      if (noPrice && this.defaultNoPrice == null) this.defaultNoPrice = noPrice.textContent;
      if (noPrice) {
        noPrice.textContent = quote && this.dataset.quoteLabel ? this.dataset.quoteLabel : this.defaultNoPrice;
        noPrice.classList.toggle('kfw__price', quote);
        noPrice.classList.toggle('kfw__price-label', !quote);
      }

      wrap.hidden = price == null;
      noPrice.hidden = price != null;
      if (disclaimer) disclaimer.hidden = price == null;

      if (bonus) {
        const amount = parseFloat(this.dataset.bonus) || 0;
        bonus.hidden = price == null || amount <= 0;
        this.querySelector('[data-kfw-bonus-amount]').textContent = this.money(amount);
      }

      if (price != null) this.countUp(this.querySelector('[data-kfw-price]'), price);
    }

    countUp(el, target) {
      const prefix = (this.dataset.prefix || '').trim();
      const render = (value) => {
        el.textContent = `${prefix ? prefix + ' ' : ''}${this.money(value)}`;
      };

      if (this.reduceMotion) return render(target);

      const duration = 900;
      const start = performance.now();
      const tick = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        render(Math.round(target * eased));
        if (t < 1) requestAnimationFrame(tick);
        else render(target);
      };
      render(0);
      requestAnimationFrame(tick);
      // pojistka, kdyby animace nedobehla (skryta zalozka)
      setTimeout(() => render(target), duration + 200);
    }

    /* --- predani na Shopify Forms --- */

    formEmbed() {
      const selector = this.dataset.formSelector || 'shopify-forms-embed';
      return (
        this.closest('.shopify-section').querySelector(selector) ||
        document.querySelector(selector)
      );
    }

    toForm() {
      const inside = this.querySelector('[data-kfw-form]');
      if (inside) inside.hidden = false;

      const target = inside || this.formEmbed();
      if (target) {
        target.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }

      this.enhanceForm();
    }

    // Formular se nacita asynchronne, proto se par sekund zkousi znovu:
    // 1) pripoji styl (stin rozbalovaciho seznamu, pripadne skryti poznamky),
    // 2) vlozi shrnuti do poznamky,
    // 3) poznamku skryje AZ po uspesnem vlozeni - jinak zustane videt.
    enhanceForm(attempt = 0) {
      const embed = this.formEmbed();
      const root = embed && embed.shadowRoot;
      const field = root
        ? Array.from(root.querySelectorAll('textarea')).find((t) => t.name && t.name.startsWith('custom#'))
        : null;

      if (!root || !field) {
        if (attempt < 20) setTimeout(() => this.enhanceForm(attempt + 1), 300);
        return;
      }

      let filled = false;
      if (this.dataset.prefill === 'true') filled = this.prefill(field);

      const rules = [];
      if (this.dataset.styleForm === 'true') {
        // --form-field-border ovlada i ramecek seznamu; kdyz ho vypneme kvuli polim,
        // seznam splyne s poli pod nim - dostane vlastni stin
        rules.push('div:has(> [role="listbox"]) { box-shadow: 0 18px 40px -12px rgb(0 0 0 / 0.28), 0 0 0 1px rgb(0 0 0 / 0.06); }');
      }
      if (this.dataset.hideNote === 'true' && filled) {
        const name = field.name.replace(/"/g, '\\"');
        rules.push(`div:has(> textarea[name="${name}"]) { display: none !important; }`);
      }
      this.applyFormStyles(root, rules.join('\n'));
    }

    applyFormStyles(root, css) {
      if (!css) return;
      if (!this._formSheet) this._formSheet = typeof CSSStyleSheet === 'function' && 'replaceSync' in CSSStyleSheet.prototype ? new CSSStyleSheet() : null;

      if (this._formSheet && 'adoptedStyleSheets' in root) {
        this._formSheet.replaceSync(css);
        if (!root.adoptedStyleSheets.includes(this._formSheet)) {
          root.adoptedStyleSheets = [...root.adoptedStyleSheets, this._formSheet];
        }
        return;
      }

      // starsi prohlizece bez adoptedStyleSheets
      let tag = root.querySelector('style[data-kfw]');
      if (!tag) {
        tag = document.createElement('style');
        tag.setAttribute('data-kfw', '');
        root.appendChild(tag);
      }
      tag.textContent = css;
    }

    // Vlozi shrnuti do pole s poznamkou, vraci true pri uspechu.
    prefill(field) {
      try {
        // opakovane kliknuti nesmi shrnuti vlozit podruhe - predchozi shrnuti nahradime
        const text = this.summaryText();
        const marker = text.split('\n')[0];
        const own = field.value.indexOf(marker);
        const before = (own > -1 ? field.value.slice(0, own) : field.value).trim();
        const value = before ? `${before}\n\n${text}` : text;
        const setter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set;
        setter.call(field, value);
        field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
        field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
        return field.value === value;
      } catch (e) {
        return false;
      }
    }

    async copy() {
      const text = this.summaryText();
      let ok = false;
      try {
        await navigator.clipboard.writeText(text);
        ok = true;
      } catch (e) {
        const area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
        area.remove();
      }
      const note = this.querySelector('[data-kfw-copied]');
      if (note && ok) {
        note.hidden = false;
        clearTimeout(this._copiedTimer);
        this._copiedTimer = setTimeout(() => { note.hidden = true; }, 3000);
      }
    }
  }

  customElements.define('trade-in-wizard', TradeInWizard);
})();
